import React from "react";
import { observer } from "mobx-react";
import { withStatus } from "./WithStatus";

const WithStatusWrapperBase = (props: React.PropsWithChildren<{ className?: string }>) => {
    const { children, className } = props;
    return <div className={className}>{children}</div>;
};

export const WithStatusWrapper = withStatus(observer(WithStatusWrapperBase));
